import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Staff } from "@common/data-models/service/staff";
import { EnpsControl } from '../enps-control/enps-control';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatSelectionListChange } from '@angular/material/list';
import { optionContainsTerm } from '../../utils/util';
import { OPTION_BLANK, OPTION_ME } from '../../enums/constants';
import { AppService } from '@src/suite/app.service';
import { TimeoutQueue } from '../../services/timeout-queue';
import { GlobalTablesService } from '../../services/global-tables-service';
import { LanguageSettings } from '../../services/language-settings';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
    selector: 'staff-id-list-multiple',
    templateUrl: './staff-id-list-multiple.html',
    styleUrls: ['./staff-id-list-multiple.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-staff-id-list-multiple',
    }
})

export class StaffIDListMultiple extends EnpsControl<string[]> {

    @Output() public selectionChange = new EventEmitter<any>();
    @Input() public includeBlank: boolean = false;
    @Input() public includeMe: boolean = false;
    @ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;

    public maxItemsToShow: number = 1;
    get allUsers(): Staff[] {
        let staff = Object.values(this.globalTablesService.Staff);
        if (this.includeMe) staff = [new Staff(OPTION_ME, this.languageSettings.PSTWebMeOption, "", "", "", "", false, "", "", "", "", this.languageSettings.PSTWebMeOption), ...staff];
        if (this.includeBlank) staff = [new Staff(OPTION_BLANK, this.languageSettings.PSTWebBlankOption, "", "", "", "", false, "", "", "", "", this.languageSettings.PSTWebBlankOption), ...staff];
        return staff;
    }

    public get items(): string[] {
        if (this.asCustomField && this.usersToShow?.length > 0) {
            return this.usersToShow;
        }
        return this.value;
    }
    public usersToShow: string[] = [];
    public usersAsTooltip: string = '';
    public set value(v: string[]) {
        super.value = v;
        if (this.asCustomField) {
            this.calculateUsersToShow();
        }
    }

    public get value(): string[] {
        return super.value;
    }

    constructor(
        public appService: AppService,
        protected ngZone: NgZone,
        protected changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        public globalTablesService: GlobalTablesService,
        protected elmRef: ElementRef,
        private languageSettings: LanguageSettings
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elmRef);
    }

    private calculateUsersToShow() {
        if (this.asCustomField) {
            this.usersToShow = this._value?.slice(0, this.maxItemsToShow);
            this.usersAsTooltip = this._value?.slice(this.maxItemsToShow)
                .map(item => this.getName(item)).join('\n');
        }
    }

    get searchLabel(): string {
        return `${this.appService.languageSettings.PSTWebSearchLabel + "..."}`;
    }

    staffFilter = new FormControl('');
    filteredOptions: Observable<string[]>;

    public displayNameByKey(key: string): string {
        return (this.globalTablesService.Staff && this.globalTablesService.Staff[key]) ? this.globalTablesService.Staff[key].GivenName + " " + this.globalTablesService.Staff[key].Surname : "";
    }

    internalValueChanged(event: MatSelectionListChange) {
        this.value = event.source.selectedOptions.selected.map((item) => item.value);
        this.calculateUsersToShow();
    }

    valueChanged() {
        if (this.isValueChanged) {
            this.isValueChanged = false;
            this.changed.emit(this.value);
        }
        this.staffFilter.setValue('');
    }

    getName(userId: string) {
        if (userId === OPTION_BLANK) {
            return this.languageSettings.PSTWebBlankOption;
        }
        if (userId === OPTION_ME) {
            return this.languageSettings.PSTWebMeOption;
        }
        return `${this.globalTablesService?.Staff[userId]?.GivenName} ${this.globalTablesService?.Staff[userId]?.Surname}`;
    }


    getEmail(userId: string) {
        return this.globalTablesService?.Staff[userId]?.Email || '';
    }

    onMenuOpened() {
        super.onMenuOpened();
        this.filteredOptions = this.staffFilter.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
        );
        setTimeout(() => {
            this.cdkVirtualScrollViewPort.scrollToIndex(0);
            this.cdkVirtualScrollViewPort.checkViewportSize();
        }, 0);
    }

    private _filter(value: string): string[] {
        return this.allUsers.filter(option => ((optionContainsTerm(option.UserID, value) || optionContainsTerm(option.DisplayName, value)) && !this.value.includes(option.UserID)))
            .map((item) => item.UserID);
    }

    remove(fruit: string): void {
        this.isValueChanged = true;
        const index = this.value.indexOf(fruit);

        if (index >= 0) {
            this.value.splice(index, 1);
            this.calculateUsersToShow();
            this.valueChanged();
        }
    }

    onSelectionChange(event: MatSelectionListChange): void {
        this.isValueChanged = true;
        let value = event.options[0].value;
        if(!this.value) this.value = [];
        this.value.push(value);
        this.calculateUsersToShow();
        this.searchBox.nativeElement.value = '';
        this.staffFilter.setValue('');
        this.selectionChange.emit({ id: value, state: this.value });
    }
}
